/* eslint-disable */

import { makeAutoObservable, observable } from "mobx"

class TestStore {
    secondsPassed = 0;
    list = [2]
    constructor() {
        makeAutoObservable(this)
    }

    increaseTimer() {
        this.secondsPassed += 1
    }

    addList(){
        console.log('add')
        this.list.push(1);
    }

    removeList(){
        this.list.pop();
    }
}


export default new TestStore();
